
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-staging/get-a-quote/[dealId]",
      function () {
        return require("private-next-pages/home-staging/get-a-quote/[dealId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-staging/get-a-quote/[dealId]"])
      });
    }
  